import React from 'react'

import { SelectedItems } from '@components/common/SelectedItems'
import { CountryFlag, VisuallyHiddenInput } from '@fourthwall/components'
import { getCountriesOptions } from '@fourthwall/utils/dist/inputs'
import { pluralize } from '@fourthwall/utils/dist/string'

import * as S from './styled'
import type { SelectedCountriesProps } from './types'

export const SelectedCountries = ({
  name,
  countriesCount,
  onAddCountry,
  onRemoveCountry,
  data: originData,
  ...props
}: SelectedCountriesProps) => {
  const data = getCountriesOptions({
    include: originData as string[],
    withMostPopular: true,
    mostPopularWithDivider: false,
  }).map((country) => country.value)

  return (
    <>
      {name && <VisuallyHiddenInput name={name} />}
      <SelectedItems
        data={data}
        maxHeight={290}
        itemsCount={countriesCount}
        header={
          <>
            {countriesCount || 'No'} {pluralize(countriesCount, 'country', 'countries')} selected
          </>
        }
        addItemsButtonLabel="Add countries"
        renderItem={(country: string) => (
          <S.CountryFlagWrapper>
            <CountryFlag countryCode={country} />
          </S.CountryFlagWrapper>
        )}
        onAddItems={onAddCountry}
        onRemoveItem={(country: string) => onRemoveCountry(country)}
        {...props}
      />
    </>
  )
}
